module.exports = __webpack_public_path__ + "static/media/thumbs_dsc_9107.34a337bd.jpg";